<template>
  <v-page page="Accounts" :breadcrumb="breadcrumb">
    <v-container ma-0 px-3 pt-0 pb-0>
      <v-layout text-xs-center>
        <v-flex mb-0 xs12 mx-2>
          <v-layout justify-center row align-center>
            <v-flex pa-0>
              <div pa-0>
                <!-- HEADER -->
                <v-layout justify-start row align-center mt-3 mb-3>
                  <v-flex align-center>
                    <div
                      v-show="(parentBAN==null) || (parentBAN =='all')"
                      class="text-xs-left align-center"
                      style="font-size: 20px; font-weight: 600;"
                    >Accounts</div>
                    <div
                      v-show="(parentBAN!=null) && (parentBAN !='all')"
                      class="text-xs-left align-center"
                      style="font-size: 20px; font-weight: 600;"
                    >Sub Account List for Parent Account # {{ parentBAN }}</div>
                  </v-flex>
                  <v-flex align-center xs7 ml-5>
                    <v-layout row>
                      <v-flex xs3>
                        <v-autocomplete
                          class="pt-0 mr-3 mt-0"
                          hide-details
                          :items="ddlAccountTypes"
                          v-model="filters.AccountType"
                          item-text="Text"
                          item-value="Text"
                          label="Account Type"
                          clearable
                          @change="filterAccounts"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs4>
                        <v-autocomplete
                          class="pt-0 mr-3 mt-0"
                          hide-details
                          :items="ddlStateProvs"
                          v-model="filters.StateProv"
                          item-text="Text"
                          item-value="Key"
                          label="State/Prov"
                          clearable
                          @change="filterAccounts"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs5>
                        <v-autocomplete
                          class="pt-0 mr-3 mt-0"
                          hide-details
                          :items="ddlAccountStatus"
                          v-model="filters.StatusId"
                          item-text="Text"
                          item-value="Value"
                          label="Status"
                          clearable
                          @change="filterAccounts"
                        >
                          <template slot="selection" slot-scope="data">
                            <v-layout row>
                              <v-flex :style="{'color': data.item.Style}">{{ data.item.Text }}</v-flex>
                            </v-layout>
                          </template>
                          <template slot="item" slot-scope="data">
                            <v-layout row>
                              <v-flex :style="{'color': data.item.Style}">{{ data.item.Text }}</v-flex>
                            </v-layout>
                          </template>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs6 ml-5>
                        <v-layout row>
                          <v-text-field
                            v-model="search"
                            label="Search"
                            single-line
                            hide-details
                            class="align-center mt-0 pt-0"
                            @keyup.enter="filterAccounts"
                          ></v-text-field>
                          <v-btn @click="filterAccounts" icon mx-2 class="TierButton my-0 py-0">
                            <v-icon style="font-size:18px">fa-search</v-icon>
                          </v-btn>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex>
                    <v-layout class="buttons" justify-end row align-center>
                      <!-- Buttons -->
                      <a
                        style="text-decoration: none"
                        class="align-center mr-4"
                        @click="exportToExcel"
                      >EXCEL</a>
                      <v-btn class="TierButton mb-1 mr-0 ml-1" :to="openCreateAccountRoute()">
                        + New Account
                        <createAccount ref="createAccount"></createAccount>
                        <editAccount ref="editAccount"></editAccount>
                      </v-btn>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <!-- END HEADER -->

                <!-- <v-layout v-show="showResetBtn && !loading" justify-start row align-center mt-0 mb-0>
                  <v-flex align-center>
                    <div class="text-xs-left align-center" style="font-size: 20px; font-weight: 600;">Parent Account # {{ parentBAN }}</div>
                  </v-flex>
                </v-layout>-->

                <!-- ACCOUNTS TABLE -->
                <v-data-table
                  :headers="headers"
                  :items="accounts"
                  :item-key="accounts.index"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                  :loading="loading"
                  :total-items="totalRecords"
                  @update:pagination="paginationUpdated"
                  hide-details
                  class="striped-table no-pagination-btn"
                >
                  <template slot="items" slot-scope="props">
                    <tr :key="props.index">
                      <td class="text-xs-left px-0">
                        <text-highlight :queries="searchHighlight">{{ props.item["AccountType"] }}</text-highlight>
                      </td>
                      <td class="text-xs-left pr-0">
                        <router-link 
                          :to="openAccountSummaryPage({ BAN: props.item.ParentBAN })"
                          class="mr-3"
                          style="text-decoration: none"
                        >
                          <text-highlight :queries="searchHighlight">{{ props.item["ParentBAN"] }}</text-highlight>
                        </router-link>
                        <!-- <router-link to="" @click.native="openEditAccountForm(props.item)">edit</router-link> -->
                      </td>
                      <td class="text-xs-left pr-0">
                        <router-link 
                          class="mr-3"
                          style="text-decoration: none"
                          :to="openAccountSummaryPage(props.item)"
                        >
                          <text-highlight :queries="searchHighlight">{{ props.item["BAN"] }}</text-highlight>
                        </router-link>
                      </td>
                      <td class="text-xs-left pr-0">
                        <text-highlight
                          :queries="searchHighlight"
                        >{{ props.item["Name1"].trim() + (props.item["Name2"] ? props.item["Name2"].trim() : '') }}</text-highlight>
                      </td>
                      <td class="text-xs-left pr-0">
                        <text-highlight :queries="searchHighlight">{{ props.item["City"] }}</text-highlight>
                      </td>
                      <td class="text-xs-left pr-0">
                        <text-highlight :queries="searchHighlight">{{ props.item["StateProv"] }}</text-highlight>
                      </td>
                      <td class="text-xs-left pr-0">
                        <text-highlight :queries="searchHighlight">{{ props.item["MailCode"] }}</text-highlight>
                      </td>
                      <td class="text-xs-left pr-0" :style="{'color':props.item.StatusColor}">
                        <text-highlight :queries="searchHighlight">{{ props.item["Status"] }}</text-highlight>
                      </td>
                      <td class="justify-end align-center text-xs-right pr-0 pt-0 pb-0">
                        <router-link
                          class="mr-2"
                          style="text-decoration: none"
                          :to="openEditAccountRoute(props.item)"
                        >EDIT</router-link>
                        <router-link
                          class="mr-2"
                          style="text-decoration: none"
                         :to="openAccountSummaryPage(props.item)"
                        >VIEW</router-link>
                        <router-link
                          class="mr-0"
                          style="text-decoration: none"
                          :to="openAccountAuditLogs(props.item)"
                        >LOG</router-link>
                      </td>
                    </tr>
                  </template>
                  <template slot="actions-append">
                  <data-table-pagination :rowsPerPage="pagination.rowsPerPage" :totalRecords="totalRecords" v-model="pagination.page" @input="paginationUpdated()"></data-table-pagination>
                  </template>
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="red lighten-3"
                    icon="fa-exclamation-triangle"
                  >
                    Your
                    search for "{{ search }}" found no results.
                  </v-alert>
                  <template slot="no-data">
                    <v-layout row justify-start align-center>
                      <v-flex xs2 style="font-size: 14px;">
                        <span v-show="hasFilter">No records found for the applied filters</span>
                      </v-flex>
                      <v-flex xs8>
                        <v-btn color="primary" @click="initialize">Reset</v-btn>
                      </v-flex>
                    </v-layout>
                  </template>
                </v-data-table>
                <!-- END USERS TABLE -->

                <v-btn
                  color="primary"
                  @click="resetAccountList"
                  v-show="showResetBtn && !loading"
                  style="margin-top: -40px;"
                >Reset</v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-page>
</template>

<script>
import VPage from "../../layouts/Default.vue";
import axios from "axios";
import * as helper from "../../helpers/global.js";
import createAccount from "./CreateAccount.vue";
import editAccount from "./EditAccount.vue";
import TextHighlight from "vue-text-highlight";
import "@/assets/css/main.css"
import DataTablePagination from "../../components/DataTablePagination.vue";

export default {
  name: "Accounts",

  components: {
    VPage,
    createAccount,
    editAccount,
    "text-highlight": TextHighlight,
    DataTablePagination
  },

  data: () => ({
    dialog: false,
    search: "",
    loading: true,
    totalRecords: 0,
    filtersChaned: true,
    parentBAN: "",
    searchHighlight: "",

    showResetBtn: false,

    filters: {},

    ddlAccountTypes: [],
    ddlStateProvs: [],
    ddlAccountStatus: [],

    rowsPerPageItems: [30, 45, 60, 100],

    // Selected by default
    pagination: {
      rowsPerPage: 30,
      descending: false,
      sortBy: "BAN",
      page: 1
    },

    breadcrumb: [
      {
        text: "Accounts",
        disabled: false,
        href: "#/accounts/all"
      },
      {
        text: "List",
        disabled: true,
        href: "#/accounts/all"
      }
    ],
    role_id: null,

    headers: [
      {
        text: "Type",
        value: "AccountType",
        width: "10%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Parent BAN",
        value: "ParentBAN",
        width: "5%",
        fixed: true,
        align: "left",
        class: "pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "BAN",
        value: "BAN",
        width: "5%",
        fixed: true,
        align: "left",
        class: "pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Name",
        value: "AccountName",
        // sortable: false,
        width: "40%",
        fixed: true,
        align: "left",
        class: "pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "City",
        value: "City",
        // sortable: false,
        width: "15%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "State/Prov",
        value: "StateProv",
        // sortable: false,
        width: "5%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Zip/Postal Code",
        value: "MailCode",
        // sortable: false,
        width: "5%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Status",
        value: "Status",
        // sortable: false,
        width: "13%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "8%",
        fixed: true,
        align: "right",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      }
    ],

    accounts: [],
    filteredAccounts: []
  }),

  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  beforeRouteUpdate (to, from, next) {
    if (to.path==from.path){
       if (to.query.BAN != null) {
        var BAN = to.query.BAN;
        this.openEditAccountForm({
          BAN: BAN
        });
      }
      if (to.query.createAccount == true || this.$route.query.createAccount == "true") {
        this.openCreateAccountForm();
      }
    }
      next()
  },

  computed: {
    hasFilter() {
      let result = false;

      Object.keys(this.filters).forEach(filter => {
        if (this.filters[`${filter}`]) {
          result = true;
        }
      });

      return result;
    }
  },

  created() {
    this.initialize();
    this.$root.$on("initialize", this.initialize);
  },

  destroyed() {
    this.$root.$off("initialize", this.initialize);
  },

  methods: {
    async initialize() {
      this.loading = true;
      this.filters = {};

      this.parentBAN = this.$route.params.parentBAN;

      if (this.parentBAN !== "all") {
        // this.filteredAccounts = this.accounts.filter( account => account.ParentBAN === this.parentBAN)
        this.filters.ParentBAN = this.parentBAN;
        this.showResetBtn = true;
      }

      if (this.$route.query.search != null){
        this.search = this.$route.query.search;
        this.searchHighlight = this.$route.query.search;
      }

      this.getDropdownOptions(
        "api/Account/GetEditAccountDdls",
        "ddlAccountTypes"
      );
      this.getDropdownOptions(
        "api/Account/GetEditAccountDdls",
        "ddlStateProvs"
      );
      this.getDropdownOptions(
        "api/Account/GetEditAccountDdls",
        "ddlAccountStatus"
      );
      this.mapKeyForStateProv();


      var paginationUpdated = await this.paginationUpdated();

      if (this.$route.query.BAN != null) {
        var BAN = this.$route.query.BAN;
        this.openEditAccountForm({
          BAN: BAN
        });
      }

      if (this.$route.query.createAccount == true || this.$route.query.createAccount == "true") {
        this.openCreateAccountForm();
      }
      
      this.loading = false;
    },

    // Get list of dropdown options
    getDropdownOptions(url, obj) {
      axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data[`${obj}`]))
        .catch(err => console.log(err));
    },
    openEditAccountRoute(item){
      var route = Object.assign({}, this.$route)
      var path = route.path
      var query = route.query

      var newQuery = Object.assign({}, query)
      newQuery.BAN = item.BAN
      return {path: path, query: newQuery}
    },
    openCreateAccountRoute(){
      var route = Object.assign({}, this.$route)
      var path = route.path
      var query = route.query

      var newQuery = Object.assign({}, query)
      newQuery.createAccount = true
      return {path: path, query: newQuery}
    },
    

    async openEditAccountForm(item) {
      await this.$refs.editAccount.open(item);
      
      this.deleteQueryString('BAN')
    },

    async openCreateAccountForm() {
     await this.$refs.createAccount.open();
      this.deleteQueryString('createAccount')
    },

    deleteQueryString(queryString){
      let query = Object.assign({}, this.$route.query);
      delete query[`${queryString}`];
      this.$router.replace({ query });
    },

    openAccountSummaryPage(item) {
      return "/account-summary/" + item.BAN;
    },
    
    test(){
console.log("testing")
    },

    async resetAccountList() {
      this.loading = true;
      this.$router.push("/accounts/all");

      this.filters = {};
      this.searchHighlight = "";
      this.search = "";

      await this.paginationUpdated();

      this.showResetBtn = false;
      this.loading = false;
    },

    async filterAccounts() {
      this.showResetBtn = true;
      this.searchHighlight = this.search;
      this.updateSearchQuery()

      await this.paginationUpdated();
    },

    async paginationUpdated() {
      this.loading = true;
      await axios
        .post(
          "/api/Account/GetPagedAccountList/",
          {
            postData: {
              pagination: this.pagination,
              filters: this.filters,
              search: this.search
            }
          },
          {
            headers: {
              "Content-type": "application/json"
            }
          }
        )
        .then(response => {
          this.accounts = response.data.accounts;
          this.totalRecords = response.data.totalRecords;
        });
      this.loading = false;
    },

    mapKeyForStateProv() {
      this.ddlStateProvs = this.ddlStateProvs.map(item => ({
        ...item,
        Key: item.Text.split("-")[1].trim()
      }));
    },
    exportToExcel() {
      axios({
        url: "/api/Excel/accounts/",
        method: "GET",
        responseType: "blob"
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "AccountList.xlsx"); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    },
    openAccountAuditLogs(item) {
      var BAN = item.BAN;
      return "/log/account/" + BAN + "/all/all";
    },
    updateSearchQuery(){
      var route = Object.assign({}, this.$route)
      var path = route.path
      var query = route.query
      var oldQuery = Object.assign({}, query)
      oldQuery.search=this.search
      this.$router.push({path:path, query:oldQuery})
    }
  }
};
</script>

<style scoped>
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
/* .v-btn--icon{
width:45px;
height:45px;
  } */
</style>
